<!--Copy right - © 2024 tecera gmbh-->
<script>
    import { fade, fly } from "svelte/transition";
    import {
        get_hymo_alarm_recipients,
        get_user_list,
        add_hymo_alarm_recipients,
        remove_hymo_alarm_recipients
    } from "../../scripts/data.js";
    import {
        selected_device,
        alarm_recipient_list,
        user_list,
    } from "../../stores.js";

    export let is_open;

    let can_close = false; // determines whether the modal can be closed
    let is_add_user_modal_open = false;
    let available_user_list = [];

    $: available_user_list = $user_list.filter(
        (user) =>
            !$alarm_recipient_list.some(
                (recipient) => recipient.email === user.email,
            ),
    );

    function close_modal() {
        if (can_close) {
            is_open = false;
            can_close = false;
            is_add_user_modal_open = false;
        }
    }

    function close_sub_modal() {
        is_add_user_modal_open = false;
    }

    function add_user_to_alarm(user) {
        add_hymo_alarm_recipients($selected_device.device.id, user.id);

        $alarm_recipient_list = [...$alarm_recipient_list, user];
    }

    function remove_user_from_alarm(user) {
        remove_hymo_alarm_recipients($selected_device.device.id, user.id);

        $alarm_recipient_list = $alarm_recipient_list.filter(
            (recipient) => recipient.email !== user.email,
        );
    }

    // reactivity to open and close the modal with delay
    $: {
        if (is_open) {
            get_hymo_alarm_recipients($selected_device.device.id);

            get_user_list();
            document.body.style.overflow = "hidden";
            document.body.classList.add("modal-open");
            setTimeout(() => {
                can_close = true; // 250ms delay to prevent closing the modal immediately
            }, 250);
        } else {
            setTimeout(() => {
                document.body.style.overflow = "auto";
                document.body.classList.remove("modal-open");
            }, 350); // enable scrolling after the modal is closed
        }
    }
</script>

{#if is_open}
    <div
        class="svelte-modal svelte-backdrop"
        tabindex="-1"
        role="dialog"
        on:mousedown|self={() => close_modal()}
        on:keydown={(e) => {
            if (e.key === "Escape") {
                close_modal();
            }
        }}
        transition:fade={{ duration: 150 }}
    >
        <div
            class="modal-dialog modal-dialog-centered"
            role="document"
            in:fly={{ y: -400, duration: 350, delay: 100 }}
            out:fly={{ y: -400, duration: 350 }}
        >
            <div class="modal-content" style="max-height:80vh;">
                <div class="modal-header">
                    <!-- Header für aktive Nutzerliste -->
                    <h5 class="modal-title" id="deleteTilte">
                        Alarmierungskreis verwalten
                    </h5>
                    <button
                        type="button"
                        class="close"
                        aria-label="Close"
                        on:click={() => close_modal()}
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <!-- Modal Body -->
                <div class="modal-body" style="overflow:auto;">
                    <h2 class="h-primary mb-1">Aktuelle Nutzerliste</h2>
                    <table class="table table-striped table-sm">
                        <tbody>
                            {#each $alarm_recipient_list as recipient}
                                <tr
                                    ><td class="align-middle"
                                        >{recipient.email}</td
                                    ><td class="col-md-1"
                                        ><button
                                            on:click={() =>
                                                remove_user_from_alarm(
                                                    recipient,
                                                )}
                                            class="btn bg-transparent btn-clear"
                                            style="margin-left:auto;"
                                            ><i class="fa fa-user-minus"
                                            ></i></button
                                        ></td
                                    ></tr
                                >
                            {/each}
                        </tbody>
                    </table>
                </div>
                <!-- Modal Footer -->
                <div class="modal-footer">
                    <button
                        type="button"
                        class="btn btn-secondary"
                        on:click={() => close_modal()}>Schließen</button
                    >
                    <button
                        class="btn btn-primary"
                        on:click={() => (is_add_user_modal_open = true)}
                    >
                        Hinzufügen
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- Nutzer zum Alarmierungskreis hinzufügen -->

    {#if is_add_user_modal_open}
        <div
            class="svelte-modal svelte-backdrop"
            tabindex="-1"
            role="dialog"
            transition:fade={{ duration: 150 }}
            on:click|self={() => close_sub_modal()}
            on:keydown={(e) => {
                if (e.key === "Escape") {
                    close_sub_modal();
                }
            }}
        >
            <div
                class="modal-dialog modal-dialog-centered"
                role="document"
                in:fly={{ y: -400, duration: 350, delay: 100 }}
                out:fly={{ y: -400, duration: 350 }}
            >
                <div class="modal-content" style="max-height:70vh;">
                    <div class="modal-header">
                        <h5 class="modal-title">Nutzer hinzufügen</h5>
                        <button
                            type="button"
                            class="close"
                            on:click={() => close_sub_modal()}
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <!-- Modal Body -->
                    <div class="modal-body" style="overflow:auto;">
                        <table class="table table-striped table-sm">
                            <tbody>
                                {#each available_user_list as user}
                                    <tr
                                        ><td class="align-middle"
                                            >{user.email}</td
                                        ><td class="col-md-1"
                                            ><button
                                                on:click={() =>
                                                    add_user_to_alarm(user)}
                                                class="btn bg-transparent btn-clear"
                                                style="margin-left:auto;"
                                                ><i class="fa fa-user-plus"
                                                ></i></button
                                            ></td
                                        ></tr
                                    >
                                {/each}
                            </tbody>
                        </table>
                    </div>
                    <!-- Modal Footer -->
                    <div class="modal-footer">
                        <button
                            type="button"
                            class="btn btn-primary"
                            on:click={() => close_sub_modal()}>Zurück</button
                        >
                    </div>
                </div>
            </div>
        </div>
    {/if}
{/if}
